<template>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro box p-5">
        <div class="flex flex-row">
            <form id="tabulator-html-filter-form" class="w-full " @submit="onFilter">
                <div class="grid grid-cols-1 gap-4 mb-4">
                    <div class="mt-2 xl:mt-0">
                        <button
                            id="create-instrument"
                            type="button"
                            class="btn btn-primary w-50 ml-4 float-right"
                            @click="createInstrument"
                        >
                            neues Instrument anlegen
                        </button>
                        <button
                            id="create-renting"
                            type="button"
                            class="btn btn-secondary w-50 float-right"
                            @click="createOrder"
                        >
                            neuen Verleih erfassen
                        </button>
                    </div>
                </div>

                <div class="grid grid-cols-1 gap-4">
                    <div class="mt-2 xl:mt-0">
                        <div>
                            <input
                                id="tabulator-html-filter-value"
                                v-model="filter.value"
                                type="text"
                                class="form-control sm:w-40 mr-2 mt-2 mb-2 sm:mt-0"
                                placeholder="Suchtext"
                            />
                            <select
                                class="form-select sm:mr-2"
                                id="type"
                                aria-label="Hersteller"
                                style="width: 300px;"
                                v-model="filter.type_id"
                            >
                                <option value="">--- Typ ---</option>
                                <option v-for="type in types" :value="type.id">
                                    {{ type.name }}
                                </option>
                            </select>
                            <select
                                class="form-select sm:mr-2 mb-2"
                                id="status"
                                aria-label="Status"
                                style="width: 300px;"
                                v-model="filter.status_id"
                            >
                                <option value="">--- Status ---</option>
                                <option v-for="status in statuses" :value="status.id">
                                    {{ status.name }}
                                </option>
                            </select>
                            <select
                                class="form-select sm:mr-2 mb-2"
                                id="size"
                                aria-label="Größe"
                                style="width: 300px;"
                                v-model="filter.size"
                            >
                                <option value="">--- Größe ---</option>
                                <option value="1/16">1/16</option>
                                <option value="1/8">1/8</option>
                                <option value="1/4">1/4</option>
                                <option value="1/2">1/2</option>
                                <option value="3/4">3/4</option>
                                <option value="4/4">4/4</option>
                            </select>
                        </div>
                        <button
                            id="tabulator-html-filter-go"
                            type="button"
                            class="btn btn-primary w-24 mr-2"
                            @click="onFilter"
                        >
                            suche
                        </button>
                        <button
                            id="tabulator-html-filter-reset"
                            type="button"
                            class="btn btn-secondary w-full sm:w-24 mt-2 sm:mt-0 sm:ml-1"
                            @click="onResetFilter"
                        >
                            abbrechen
                        </button>
                    </div>
                </div>
                <div class="grid grid-cols-1 gap-4 mt-4">
                    <div class="sm:flex items-center sm:mr-4 mt-2 xl:mt-0">
                        <span class="form-label mb-0 mr-3">Ausleihstatus</span>
                        <div class="inline-flex" role="radiogroup" aria-label="Instrumente nach Ausleihstatus filtern">
                            <button
                                type="button"
                                class="btn rounded-r-none"
                                :class="filter.availability === '' ? 'btn-primary' : 'btn-outline-secondary'"
                                :aria-pressed="filter.availability === ''"
                                @click="setAvailabilityFilter('')"
                            >
                                Alle
                            </button>
                            <button
                                type="button"
                                class="btn rounded-none border-l-0"
                                :class="filter.availability === 'free' ? 'btn-primary' : 'btn-outline-secondary'"
                                :aria-pressed="filter.availability === 'free'"
                                @click="setAvailabilityFilter('free')"
                            >
                                Nur freie
                            </button>
                            <button
                                type="button"
                                class="btn rounded-l-none border-l-0"
                                :class="filter.availability === 'rented' ? 'btn-primary' : 'btn-outline-secondary'"
                                :aria-pressed="filter.availability === 'rented'"
                                @click="setAvailabilityFilter('rented')"
                            >
                                Nur herausgegebene
                            </button>
                        </div>
                    </div>
                </div>

            </form>
        </div>

        <div class="overflow-x-auto scrollbar-hidden">
            <div
                id="tabulator"
                ref="tableRef"
                class="mt-5 table-report table-report--tabulator"
            ></div>
        </div>
    </div>

    <!-- BEGIN: View pupil Modal -->
    <Modal
        v-if="viewPupilModal"
        :show="viewPupilModal"
        :backdrop="'static'"
        :size="'modal-xl'"
    >
        <ModalBody class="p-0">
            <ShowPupilForm
                :pupil="viewPupil"
                @save="onViewPupilEnd"
                @close="onViewPupilEnd"
                @hidden="onViewPupilEnd"
            />
        </ModalBody>
    </Modal>
    <!-- END: View pupil Modal -->

    <!-- BEGIN: Edit rental Modal -->
    <Modal
        v-if="editRentalModal"
        :show="editRentalModal"
        :backdrop="'static'"
        :size="'modal-xl'"
    >
        <ModalBody class="p-0">
            <EditRentalForm
                :rental="editRental"
                @save="onEditRentalEnd"
                @close="onEditRentalEnd"
                @hidden="onEditRentalEnd"
            />
        </ModalBody>
    </Modal>
    <!-- END: Edit rental Modal -->

    <!-- BEGIN: Edit instrument Modal -->
    <Modal
        v-if="editInstrumentModal"
        :show="editInstrumentModal"
        :backdrop="'static'"
        :size="'modal-xxl'"
        @hidden="onEditEnd()"
    >
        <ModalBody class="p-0">
            <EditInstrumentForm
                :instrument="editInstrument"
                @save="onEditEnd"
                @close="onEditEnd"
                @hidden="onEditEnd"
                @update="onEditEnd"
            />
        </ModalBody>
    </Modal>
    <!-- END: Edit instrument Modal -->

    <!-- BEGIN: Delete Confirmation Modal -->
    <Modal
        :backdrop="'static'"
        :show="deleteConfirmationModal"
        @hidden="onDeleteEnd()"
    >
        <ModalBody class="p-0">
            <div class="p-5 text-center">
                <XCircleIcon class="w-16 h-16 text-danger mx-auto mt-3"/>
                <div class="text-3xl mt-5">Eintrag archivieren?</div>
                <div class="text-slate-500 mt-2">
                    Wollen Sie diesen Datensatz wirklich archivieren?
                </div>
            </div>
            <div class="px-5 pb-8 text-center">
                <button
                    type="button"
                    @click="onDeleteEnd()"
                    class="btn btn-outline-secondary w-24 mr-1"
                >
                    abbrechen
                </button>
                <button
                    type="button"
                    class="btn btn-danger w-24"
                    @click="doDelete()"
                >
                    ja
                </button>
            </div>
        </ModalBody>
    </Modal>
    <!-- END: Delete Confirmation Modal -->
</template>

<script>
import axios from "axios";
import { createIcons, icons } from "lucide";
import dom from "@left4code/tw-starter/dist/js/dom";
import Tabulator from "tabulator-tables";
import EditRentalForm from '../../partials/EditRentalForm';
import EditInstrumentForm from '../../partials/EditInstrumentForm';
import ShowPupilForm from "../../partials/ShowPupilForm.vue";
import authHeader from "../../services/auth-header";

export default {
    name: "Instruments",

    components: {
        ShowPupilForm,
        EditRentalForm,
        EditInstrumentForm,
    },

    data() {
        return {
            deleteConfirmationModal : false,
            deleteModel             : null,
            editInstrumentModal     : false,
            editInstrument          : null,
            editRowIndex            : null,
            editRentalModal         : false,
            editRental              : null,
            viewPupilModal          : false,
            viewPupil               : null,
            tabulator               : null,
            types                   : [],
            statuses                : [],
            filter                  : {
                field: 'name',
                type: '=',
                value: '',
                type_id: '',
                status_id: '',
                size: '',
                availability: ''
            }
        }
    },

    mounted() {
        this.initTabulator();

        axios
            .get(this.$store.state.config.apiUrl + '/categorySimple', { headers: authHeader() })
            .then(response => {
                this.types = response.data.data;
            });

        axios
            .get(this.$store.state.config.apiUrl + '/statusSimple', { headers: authHeader() })
            .then(response => {
                this.statuses = response.data.data;
            });
    },

    methods: {

        update(updatedModel) {
            console.log(this.editRowIndex);
            console.log(updatedModel);
            this.updateTableRow(updatedModel);
        },

        showIcons() {
            setTimeout(() => {
                createIcons({
                    icons,
                    color: '#fff',
                    "stroke-width": 2,
                    nameAttr: "data-lucide",
                });
            }, 500);
        },

        onDeleteEnd() {
            this.deleteConfirmationModal = false;
            this.deleteModel = null;

            this.onFilter();
            this.enableScrolling();
            this.showIcons();
        },

        onEditEnd(updatedModel) {
            this.editInstrumentModal = false;
            this.editInstrument = null;

            this.onFilter();
            this.enableScrolling();
            this.showIcons();
        },

        onEditRentalEnd(updatedModel) {
            this.editRentalModal = false;
            this.editRental = null;

            this.onFilter();
            this.enableScrolling();
            this.showIcons();
        },

        onViewPupilEnd() {
            this.viewPupilModal = false;
            this.viewPupil = null;
            this.enableScrolling();
            this.showIcons();
        },

        createOrder() {
            this.editRentalModal = true;
            this.editRental = { };
        },

        updateTableRow(updatedModel) {
            if (updatedModel) {
                this.tabulator.updateOrAddRow(this.editRowIndex, updatedModel);
                this.editRowIndex = null;
            }
        },

        onFilter(ev) {
            if (ev != null) {
                ev.preventDefault();
                ev.stopPropagation();
            }

            this.tabulator.setFilter([
                { 'field': this.filter.field, 'type': this.filter.type, 'value': this.filter.value },
                { 'field': 'type', 'type': this.filter.type, 'value': this.filter.type_id },
                { 'field': 'size', 'type': this.filter.type, 'value': this.filter.size },
                { 'field': 'status', 'type': this.filter.type, 'value': this.filter.status_id },
                { 'field': 'rented', 'type': this.filter.type, 'value': this.filter.availability === 'rented' ? 'true' : '' },
                { 'field': 'not_rented', 'type': this.filter.type, 'value': this.filter.availability === 'free' ? 'true' : '' },
            ]);
        },

        setAvailabilityFilter(availability) {
            this.filter.availability = availability;
            this.onFilter();
        },

        onResetFilter(ev) {
            this.filter.field = "name";
            this.filter.type = "like";
            this.filter.value = "";
            this.filter.type_id = "";
            this.filter.status_id = "";
            this.filter.size = "";
            this.filter.availability = "";
            this.tabulator.clearFilter();
            this.onFilter(ev);
        },

        initTabulator() {
            let _self = this;
            this.tabulator = new Tabulator(this.$refs.tableRef, {
                ajaxURL: this.$store.state.config.apiUrl + '/instrument',
                ajaxFiltering: true,
                ajaxSorting: true,
                ajaxConfig: {
                    method: 'GET',
                    headers: {
                        'Content-type': 'application/json; charset=utf-8',
                        'Authorization': 'Bearer ' + this.$store.state.auth.accessToken
                    }
                },
                ajaxError: function(response) {
                    if (401 === response.status) {
                        _self.$store.dispatch('auth/logout', _self.$store.state.auth.user);
                        _self.$router.push('/login');
                    } else {
                        return Promise.reject(response);
                    }
                },
                printAsHtml: true,
                printStyled: true,
                pagination: "remote",
                paginationSize: 15,
                paginationSizeSelector: [10, 15, 25, 50],
                layout: "fitColumns",
                responsiveLayout:"hide",
                placeholder: "Es wurden keine Ergebnisse gefunden",
                columns: [
                    {
                        title: "Inv.Nr.",
                        headerTooltip: 'Inventarnummer',
                        field: "sku",
                        vertAlign: "middle",
                        responsive: 0
                    },
                    {
                        title: "Seriennr.",
                        headerTooltip: 'Seriennummer',
                        field: "serial_number",
                        vertAlign: "middle",
                        responsive: 0
                    },
                    {
                        title: "Typ",
                        headerTooltip: 'Typ',
                        field: "category.name",
                        vertAlign: "middle",
                        responsive: 0
                    },
                    {
                        title: "Hersteller",
                        headerTooltip: 'Hersteller',
                        field: "producer.name",
                        vertAlign: "middle",
                    },
                    {
                        title: "Schule",
                        headerTooltip: 'Schule',
                        field: "school.name",
                        vertAlign: "middle",
                    },
                    {
                      title: "Größe",
                      headerTooltip: 'Größe',
                      field: "size",
                      vertAlign: "middle",
                    },
                    {
                      title: "Status",
                      headerTooltip: 'Status',
                      field: "status.name",
                      vertAlign: "middle",
                    },
                    {
                        title: "Schüler",
                        headerTooltip: 'Schüler',
                        field: "rentings",
                        vertAlign: "middle",
                        formatter: function (cell, formatterParams, onRendered) {
                          let instrument = cell.getData();
                          if (instrument.rentings != null && instrument.rentings.length > 0) {
                            let res = instrument.rentings.filter(x => x.end == null);
                            if (res.length > 0) {
                                const wrapper = document.createElement('div');
                                const link = document.createElement('a');
                                wrapper.className = 'flex justify-center items-center';
                                link.className = 'flex items-center mr-3 view';
                                link.href = 'javascript:;';
                                link.title = 'Details';
                                link.textContent = res[0].pupil.pupil_name;
                                link.addEventListener('click', function () {
                                    _self.viewPupilModal = true;
                                    _self.viewPupil = res[0].pupil;
                                });
                                wrapper.appendChild(link);

                                return wrapper;
                            }
                          }
                        }
                    },
                    {
                        title: "",
                        minWidth: 60,
                        hozAlign: "center",
                        vertAlign: "middle",
                        headerSort: false,
                        print: false,
                        download: false,
                        formatter: function(cell) {
                            let rowIndex = cell.getRow().getIndex();
                            let a = dom(`<div class="flex justify-center items-center">
                                <a
                                    class="btn btn-xs btn-success flex items-center mr-3 edit"
                                    href="javascript:;"
                                    title="bearbeiten"
                                >
                                    <i data-lucide="wrench" class="w-4 h-4 mr-1 edit"></i>
                                </a>
                                <a
                                    class="btn btn-xs btn-warning flex items-center mr-3 trash"
                                    href="javascript:;"
                                    title="löschen"
                                >
                                    <i data-lucide="trash" class="w-4 h-4 mr-1 trash"></i>
                                </a>
                            </div>`);

                            if (!_self.userHasRole(['admin'])) {
                                a = dom(`<div class="flex justify-center items-center">
                                    <a
                                        class="btn btn-xs btn-success flex items-center mr-3 edit"
                                        href="javascript:;"
                                        title="bearbeiten"
                                    >
                                        <i data-lucide="wrench" class="w-4 h-4 mr-1 edit"></i>
                                    </a>
                                </div>`);
                            }

                            dom(a).find('a.edit').on("click", function (ev) {
                                let instrument = cell.getData();
                                _self.onEdit(instrument, rowIndex);
                            });

                            dom(a).find('a.trash').on("click", function (ev) {
                                let instrument = cell.getData();
                                _self.onDelete(instrument);
                            });

                            return a[0];
                        }
                    }
                ],
                renderComplete() {
                    createIcons({
                        icons,
                        color: '#fff',
                        "stroke-width": 2,
                        nameAttr: "data-lucide",
                    });
                },
            });
        },

        createInstrument() {
            this.editRowIndex = 0;
            this.editInstrument = {};
            this.editInstrumentModal = true;
        },

        onEdit(order, rowIndex) {
            this.editRowIndex = rowIndex;
            this.editInstrument = order;
            this.editInstrumentModal = true;
        },

        onDelete(order) {
            this.deleteModel = order;
            this.deleteConfirmationModal = true;
        },

        doDelete() {
            axios
                .delete(this.$store.state.config.apiUrl + '/instrument/' + this.deleteModel.id, { headers: authHeader() })
                .then(response => {
                    this.deleteConfirmationModal = false;
                    this.tabulator.deleteRow(this.deleteModel.id);

                    this.deleteModel = null;
                    this.showNotification(true, 'Archivieren', 'Der Datensatz wurde archiviert');
                })
                .catch(error => {
                    this.showNotification(true, 'Archivieren', error.response.data.message);
                });
        },
    }
}
</script>
